/* eslint-disable import/no-anonymous-default-export */
export const order = { ASC: 'DESC', DESC: 'ASC' };
export const initialFilters = [
  { Coluna: 'Ordem', Ordem: 'ASC', Text: 'Relevância' },
  { Coluna: 'NDownload', Ordem: 'ASC', Text: 'Nº Downloads' },
  { Coluna: 'NRDocumento', Ordem: 'ASC', Text: 'Código' },
  { Coluna: 'Titulo', Ordem: 'ASC', Text: 'Título' },
  { Coluna: 'Versao', Ordem: 'ASC', Text: 'Versão' },
  { Coluna: 'AgrupamentoId', Ordem: 'ASC', Text: 'Classificação' },
  { Coluna: 'DTCadastro', Ordem: 'ASC', Text: 'Data Cadastro' },
];
export const tipoDocFilter = [
  { id: 1, text: 'Normas Técnicas' },
  { id: 2, text: 'Desenho Padrão' },
  { id: 0, text: 'Todos' },
];

export const tipoDocRelQuantity = [
  { id: 3, text: '.xls' },
  { id: 4, text: '.csv' },
];
